import {
    createTemplate,
    deleteTemplate,
    editTemplate,
    editTemplateInfo,
    getTemplateById,
    getTemplates,
} from './templates.action';

export {templatesReducer} from './templates.reducer';
export {watchTemplate} from './templates.saga';

export const templateActions = {
    /** Template Actions */
    createTemplate,
    editTemplate,
    editTemplateInfo,
    deleteTemplate,
    getTemplates,
    getTemplateById,
    /** End */
}

